import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../assets/shared/failure.svg'


const _hoisted_1 = { class: "bg-white min-h-screen flex flex-col" }
const _hoisted_2 = { class: "flex flex-grow max-md:flex-col" }
const _hoisted_3 = {
  key: 0,
  class: "flex flex-col w-1/5 max-md:ml-0 max-md:w-full bg-primary-purple"
}
const _hoisted_4 = { class: "flex flex-col mt-14 flex-grow" }
const _hoisted_5 = { class: "flex justify-center mb-4" }
const _hoisted_6 = {
  key: 0,
  role: "alert",
  class: "flex gap-2 w-1/2 justify-center p-2.5 mt-6 text-sm leading-5 text-center text-red-900 bg-red-50 rounded-lg max-md:flex-wrap",
  style: {"max-height":"80px","overflow-y":"auto"}
}
const _hoisted_7 = { class: "flex flex-col w-1/2 mx-auto justify-center max-md:mt-4 max-md:w-full" }
const _hoisted_8 = { class: "mt-6 text-left" }
const _hoisted_9 = { class: "mt-6 text-left" }
const _hoisted_10 = {
  key: 0,
  class: "mt-6 text-left"
}
const _hoisted_11 = {
  key: 1,
  class: "flex flex-col mt-6 w-full text-sm leading-none text-left"
}
const _hoisted_12 = { class: "flex overflow-hidden items-center mt-1 w-full text-gray-500 whitespace-nowrap rounded-md border border-gray-300 border-solid" }
const _hoisted_13 = { class: "flex flex-col flex-grow mt-6 basis-1/2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StepsList = _resolveComponent("StepsList")!
  const _component_BaseLabel = _resolveComponent("BaseLabel")!
  const _component_BaseInput = _resolveComponent("BaseInput")!
  const _component_FooterSection = _resolveComponent("FooterSection")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.pendingCompanyDetails)
        ? (_openBlock(), _createElementBlock("aside", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "flex flex-col ml-10 text-left" }, [
                _createElementVNode("span", { class: "text-white text-3xl font-semibold leading-9" }, [
                  _createTextVNode(" Get Started "),
                  _createElementVNode("br")
                ])
              ], -1)),
              _createVNode(_component_StepsList, { currentStep: 0 })
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("section", {
        class: _normalizeClass([
          'flex flex-col justify-center mt-10 pt-6 pb-1 max-md:w-full',
          _ctx.pendingCompanyDetails ? 'w-4/5' : 'w-full',
        ])
      }, [
        _createElementVNode("div", _hoisted_5, [
          (_ctx.errorMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full" }, [
                  _createElementVNode("img", {
                    src: _imports_0,
                    alt: "Error Icon",
                    class: "w-4 h-4"
                  })
                ], -1)),
                _createElementVNode("p", null, _toDisplayString(_ctx.errorMessage), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[10] || (_cache[10] = _createElementVNode("h1", { class: "text-3xl font-semibold leading-9 text-center text-zinc-800" }, " Personal Details ", -1)),
          _cache[11] || (_cache[11] = _createElementVNode("p", { class: "mt-3 text-base leading-6 text-center text-neutral-700" }, " Add your personal details to get started ", -1)),
          _createElementVNode("form", {
            onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"])),
            class: "flex flex-col gap-2"
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_BaseLabel, {
                forAttr: "firstName",
                text: "First Name",
                class: "text-sm font-medium leading-5 text-zinc-800"
              }),
              _createVNode(_component_BaseInput, {
                id: "firstName",
                modelValue: _ctx.firstName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.firstName) = $event)),
                placeholder: "John",
                className: "px-3.5 py-2.5 mt-1 text-sm leading-5 text-gray-900 whitespace-nowrap bg-white rounded-md border border-gray-300 border-solid shadow-sm max-md:pr-5 w-full",
                required: ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_BaseLabel, {
                forAttr: "lastName",
                text: "Last Name",
                class: "text-sm font-medium leading-5 text-zinc-800"
              }),
              _createVNode(_component_BaseInput, {
                id: "lastName",
                modelValue: _ctx.lastName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.lastName) = $event)),
                placeholder: "Doe",
                className: "px-3.5 py-2.5 mt-1 text-sm leading-5 text-gray-900 whitespace-nowrap bg-white rounded-md border border-gray-300 border-solid shadow-sm max-md:pr-5 w-full",
                required: ""
              }, null, 8, ["modelValue"])
            ]),
            (_ctx.pendingCompanyDetails)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_component_BaseLabel, {
                    forAttr: "companyName",
                    text: "Company Name",
                    class: "text-sm font-medium leading-5 text-zinc-800"
                  }),
                  _createVNode(_component_BaseInput, {
                    id: "companyName",
                    modelValue: _ctx.companyName,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.companyName) = $event)),
                    placeholder: "Acme Corporation",
                    className: "px-3.5 py-2.5 mt-1 text-sm leading-5 text-gray-900 whitespace-nowrap bg-white rounded-md border border-gray-300 border-solid shadow-sm max-md:pr-5 w-full",
                    required: ""
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.pendingCompanyDetails)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _cache[9] || (_cache[9] = _createElementVNode("label", {
                    for: "softwareUrl",
                    class: "font-medium text-zinc-800"
                  }, "Company Website", -1)),
                  _createElementVNode("div", _hoisted_12, [
                    _cache[8] || (_cache[8] = _createElementVNode("span", { class: "self-stretch py-2.5 pr-3 pl-3.5 bg-gray-100 rounded-md" }, "https://", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      id: "url",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.companyWebsite) = $event)),
                      class: "overflow-hidden flex-1 shrink self-stretch py-2.5 pr-3.5 pl-3 my-auto bg-white rounded-none",
                      placeholder: "www.example.com",
                      required: ""
                    }, null, 512), [
                      [_vModelText, _ctx.companyWebsite]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_BaseLabel, {
                forAttr: "title",
                text: "Your Title",
                class: "text-sm font-medium leading-5 text-zinc-800 text-left"
              }),
              _createVNode(_component_BaseInput, {
                type: "text",
                id: "title",
                modelValue: _ctx.title,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.title) = $event)),
                placeholder: "Your title",
                className: "flex-grow px-3.5 py-2.5 mt-1 text-sm leading-5 text-gray-900 whitespace-nowrap bg-white rounded-md border border-gray-300 border-solid shadow-sm max-md:pr-5 w-full",
                required: ""
              }, null, 8, ["modelValue"])
            ])
          ], 32)
        ]),
        _createVNode(_component_FooterSection, {
          isDisabled: _ctx.isDisabled,
          onNext: _ctx.goNext
        }, null, 8, ["isDisabled", "onNext"])
      ], 2)
    ])
  ]))
}